/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchPinAdminDto } from '../models/BranchPinAdminDto';
import type { Pagination1OfBranchPinAdminDto } from '../models/Pagination1OfBranchPinAdminDto';
import type { PostBranchPinRequestAdmin } from '../models/PostBranchPinRequestAdmin';
import type { PutBranchPinRequestAdmin } from '../models/PutBranchPinRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchPinsService {
    /**
     * **Required Policy:** `ViewBranchPins`
     * @returns BranchPinAdminDto OK
     * @throws ApiError
     */
    public static getBranchPinAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<BranchPinAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchpins/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchPins`
     * @returns BranchPinAdminDto OK
     * @throws ApiError
     */
    public static putBranchPinAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBranchPinRequestAdmin,
    }): CancelablePromise<BranchPinAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branchpins/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteBranchPins`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBranchPinAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/branchpins/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchPins`
     * @returns Pagination1OfBranchPinAdminDto OK
     * @throws ApiError
     */
    public static getBranchPinsAdmin({
        id,
        branchId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        branchId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfBranchPinAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchpins',
            query: {
                'id': id,
                'branchId': branchId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchPins`
     * @returns BranchPinAdminDto Created
     * @throws ApiError
     */
    public static postBranchPinAdmin({
        requestBody,
    }: {
        requestBody?: PostBranchPinRequestAdmin,
    }): CancelablePromise<BranchPinAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branchpins',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
